// Filter/sort links come from Shopify (value.url_to_add etc.) and don't always
// carry ?view=bundle-builder. Without it the request renders the default
// collection template and its regular product cards end up in the grid.
function bundleEnsureView(url) {
    const template = $('.bundle-builder__categories').attr('data-template');
    const parsed = new URL(url, window.location.origin);
    if (template && !parsed.searchParams.has('view')) {
        parsed.searchParams.set('view', template);
    }
    return parsed.pathname + parsed.search;
}

// Swaps the desktop sidebar and the mobile slideout copy explicitly. The theme
// slideout (createSlideoutEl in theme.js) moves the mobile content into an
// <aside> at the end of the page, so the two can't be matched up by DOM order.
// Only the inner .js-col-filter-sidebar is replaced: the drawer's close button
// sits outside it and has a click listener bound directly by the theme.
function bundleSwapSidebars($response) {
    const sidebar = '.js-col-filter-sidebar';
    const desktopHTML = $response.find('[data-collection-sidebar-filters] ' + sidebar).html() || '';
    $('[data-collection-sidebar-filters] ' + sidebar).html(desktopHTML);

    const mobileHTML = $response.find('[data-wau-slideout-content="collection-sidebar"] ' + sidebar).html() || '';
    let $mobile = $('aside[data-wau-slideout="collection-sidebar"] ' + sidebar);
    if (!$mobile.length) $mobile = $('[data-wau-slideout-content="collection-sidebar"] ' + sidebar);
    $mobile.html(mobileHTML);
}

const BUNDLE_TYPE_PARAM = 'filter.p.product_type';

// Re-applies the "+ More" cut-off after values were removed from a list,
// keeping whichever expanded/collapsed state it was in.
function bundleReindexFilterList($ul) {
    const $items = $ul.children('li').not('.show-more-container, .show-less-container');
    const $more = $ul.children('.show-more-container');
    const $less = $ul.children('.show-less-container');
    const collapsed = $more.length && !$more.hasClass('is_hide');

    $items.each(function(index) {
        const hidden = index >= 6;
        $(this).toggleClass('hidden-filter', hidden).toggleClass('force-hide2', hidden && !!collapsed);
    });
    if ($items.length <= 6) {
        $more.addClass('is_hide');
        $less.addClass('is_hide');
    }
}

// While a Type value is active, Liquid can only see products of the selected
// type(s), so the sidebar lists every type Shopify knows about, including ones
// whose products the bundle grid hides (unlisted, sold out, no image...).
// Fetch the same URL without the Type params, where the sidebar's own prune
// runs, and keep only the types that list renders. Resolves to a function that
// applies the result to the live sidebars, so callers can fetch in parallel and
// apply after their own DOM swap.
async function bundlePruneTypeFilter(url) {
    const parsed = new URL(bundleEnsureView(url), window.location.origin);
    const selector = '.js-col-filter-sidebar [data-filter-param="' + BUNDLE_TYPE_PARAM + '"]';
    const clearPending = () => $(selector).removeClass('bb-type-pending');
    if (!parsed.searchParams.has(BUNDLE_TYPE_PARAM)) return clearPending;

    parsed.searchParams.delete(BUNDLE_TYPE_PARAM);
    let $source;
    try {
        const html = await $.ajax({ url: parsed.pathname + parsed.search, method: 'GET', dataType: 'html' });
        $source = $('<div>').append($.parseHTML(html)).find(selector).first();
    } catch (err) {
        console.error('bundlePruneTypeFilter failed:', err);
        return clearPending;
    }

    return function() {
        const visible = {};
        $source.find('li[data-value]').each(function() {
            visible[$(this).attr('data-value')] = $(this).find('.filter__count').text();
        });

        $(selector).each(function() {
            const $ul = $(this).children('ul');
            $ul.children('li[data-value]').each(function() {
                const $li = $(this);
                const value = $li.attr('data-value');
                // The selected type keeps its row but takes the per-card count.
                if ($li.hasClass('current')) {
                    if (visible[value]) $li.find('.filter__count').text(visible[value]);
                    return;
                }
                if (!(value in visible)) {
                    $li.remove();
                } else if (visible[value]) {
                    $li.find('.filter__count').text(visible[value]);
                }
            });
            bundleReindexFilterList($ul);
        });
        clearPending();
    };
}

const BUNDLE_TAG_PARAM = 'filter.p.tag';

// Same idea for the Gender counts: while a gender is selected, Liquid only sees
// that gender's products, so the other genders would show Shopify's raw counts.
// Fetch the URL without the tag params, where the sidebar recounts from the
// rendered cards, and copy those counts into the live sidebars.
async function bundleRecountGenderFilter(url) {
    const parsed = new URL(bundleEnsureView(url), window.location.origin);
    const selector = '.js-col-filter-sidebar [data-filter-param="' + BUNDLE_TAG_PARAM + '"]';
    const clearPending = () => $(selector).removeClass('bb-gender-pending');
    if (!parsed.searchParams.has(BUNDLE_TAG_PARAM)) return clearPending;

    parsed.searchParams.delete(BUNDLE_TAG_PARAM);
    let $source;
    try {
        const html = await $.ajax({ url: parsed.pathname + parsed.search, method: 'GET', dataType: 'html' });
        $source = $('<div>').append($.parseHTML(html)).find(selector).first();
    } catch (err) {
        console.error('bundleRecountGenderFilter failed:', err);
        return clearPending;
    }

    return function() {
        const counts = {};
        $source.find('li[data-value]').each(function() {
            counts[$(this).attr('data-value')] = $(this).find('.filter__count').text();
        });
        $(selector).find('li[data-value]').each(function() {
            const value = $(this).attr('data-value');
            if (counts[value]) $(this).find('.filter__count').text(counts[value]);
        });
        clearPending();
    };
}

let bundleRequestId = 0;

// Fetches a bundle-builder collection URL and swaps the grid, toolbar and
// filter sidebars, then lets listeners (e.g. 250-variant fix) re-run. Only the
// latest request renders, so overlapping sort/filter/price clicks can't land
// out of order.
async function loadBundleCollection(url) {
    url = bundleEnsureView(url);
    const id = ++bundleRequestId;
    const $categories = $('.bundle-builder__categories');
    const previousUrl = $categories.attr('data-collection');

    // Record intent up front so the next sort/price URL builds on this one.
    $categories.attr('data-collection', url);
    $('body').addClass('pointer-events-none');
    $('.body-loader').addClass('active');
    try {
        const [responseHTML, applyTypePrune, applyGenderCounts] = await Promise.all([
            $.ajax({ url: url, method: 'GET', dataType: 'html' }),
            bundlePruneTypeFilter(url),
            bundleRecountGenderFilter(url)
        ]);
        if (id !== bundleRequestId) return;
        const $response = $('<div>').append($.parseHTML(responseHTML));

        $('#main-collection-product-grid').html($response.find('#main-collection-product-grid').html());
        $('#CollectionProductFiltersHead').html($response.find('#CollectionProductFiltersHead').html());
        // The shared toolbar snippet always renders "Featured" as the label;
        // show the sort it marked as current instead.
        const sortLabel = $('#CollectionProductFiltersHead .js-hz-filter-list li.current').attr('data-placeholder');
        if (sortLabel) $('#CollectionProductFiltersHead .collection__filtering .chosen-value').attr('placeholder', sortLabel);
        bundleSwapSidebars($response);
        applyTypePrune();
        applyGenderCounts();

        document.dispatchEvent(new Event('CollectionUpdated', { bubbles: true, cancelable: false }));
    } catch (err) {
        console.error('loadBundleCollection failed:', err);
        if (id === bundleRequestId) $categories.attr('data-collection', previousUrl);
    } finally {
        if (id === bundleRequestId) {
            $('.body-loader').removeClass('active');
            $('body').removeClass('pointer-events-none');
        }
    }
}

document.addEventListener("DOMContentLoaded", async function() {

    // Each card's hidden select.variant__select is built from
    // {% for variant in card.variants %} in bundle-card.liquid, capped at
    // Liquid's 250-variant limit same as everywhere else in the theme. On
    // a product past that cap, sizes/styles whose variant sits beyond #250
    // never get an <option>, so they always read as sold out here even
    // when actually in stock. Reuses the same Storefront API augmentation
    // already used on PDP/CLP; no-ops unless a card actually hit the cap.
    function readMoneyFormat() {
        var cfg = document.getElementById('cart-config');
        if (!cfg) return '${{amount}}';
        try {
            return JSON.parse(cfg.innerHTML || '{}').money_format || '${{amount}}';
        } catch (e) {
            return '${{amount}}';
        }
    }

    // Cards are re-rendered on every filter/sort, so cache the full variant
    // list per handle instead of refetching it each time.
    const variantFetchCache = {};

    function fixBundleCardVariants() {
        if (!window.theme || !theme.ProductVariants) return;
        var moneyFormat = readMoneyFormat();

        document.querySelectorAll('.bundle-card[data-variant-count="250"]').forEach(function (card) {
            if (card.dataset.variantsFixed) return;
            var handle = card.dataset.productHandle;
            if (!handle) return;
            card.dataset.variantsFixed = 'true';

            var select = card.querySelector('select.variant__select[name="variant"]');
            if (!select) return;

            var existingIds = {};
            select.querySelectorAll('option').forEach(function (opt) {
                existingIds[opt.value] = true;
            });

            if (!variantFetchCache[handle]) {
                // Drop a failed fetch so the next CollectionUpdated retries it.
                variantFetchCache[handle] = theme.ProductVariants.fetchAllVariantsForHandle(handle)
                    .catch(function (err) {
                        delete variantFetchCache[handle];
                        throw err;
                    });
            }

            variantFetchCache[handle].then(function (variants) {
                variants.forEach(function (v) {
                    var idStr = String(v.id);
                    if (existingIds[idStr]) return;
                    existingIds[idStr] = true;

                    var opt = document.createElement('option');
                    opt.value = v.id;
                    opt.setAttribute('data-title', v.title);
                    opt.setAttribute('data-price', v.price);
                    if (v.compare_at_price) opt.setAttribute('data-compare-price', v.compare_at_price);
                    opt.setAttribute('data-price-money', theme.Helpers.formatMoney(v.price, moneyFormat));
                    if (v.compare_at_price > v.price) {
                        opt.setAttribute('data-compare-price-money', theme.Helpers.formatMoney(v.compare_at_price, moneyFormat));
                    }
                    if (v.featured_image && v.featured_image.src) {
                        opt.setAttribute('data-img', v.featured_image.src);
                    }
                    opt.setAttribute('data-available', v.available);
                    opt.setAttribute('data-option1', v.option1 || '');
                    opt.setAttribute('data-option2', v.option2 || '');
                    opt.setAttribute('data-option3', v.option3 || '');
                    select.appendChild(opt);
                });

                // If the customer already picked a size/style while this
                // fetch was still in flight, the Sold Out check ran against
                // the incomplete list and nothing re-evaluates it on its
                // own once the missing variant lands above. Re-trigger it
                // now against the now-complete option list.
                $(card).find('select.bundle-card__select').first().trigger('change');
            }).catch(function (err) {
                console.error('fixBundleCardVariants failed:', err);
                delete card.dataset.variantsFixed;
            });
        });
    }

    fixBundleCardVariants();
    document.addEventListener('CollectionUpdated', fixBundleCardVariants);

    $('body').on('click', '[data-show-more]', function() {
        const parentEle = $(this).closest('ul');
        parentEle.find('.show-more-container').addClass('is_hide');
        parentEle.find('.show-less-container').removeClass('is_hide');
        parentEle.find('li.hidden-filter').removeClass('force-hide2');
    })

    $('body').on('click', '[data-show-less]', function() {
        const parentEle = $(this).closest('ul');
        parentEle.find('.show-less-container').addClass('is_hide');
        parentEle.find('.show-more-container').removeClass('is_hide');
        parentEle.find('li.hidden-filter').addClass('force-hide2');
    })

    // Skip if a newer collection load replaced the sidebar in the meantime;
    // that load runs its own prune.
    const initialRequestId = bundleRequestId;
    bundlePruneTypeFilter(window.location.pathname + window.location.search)
        .then(applyTypePrune => {
            if (initialRequestId === bundleRequestId) applyTypePrune();
        });
    bundleRecountGenderFilter(window.location.pathname + window.location.search)
        .then(applyGenderCounts => {
            if (initialRequestId === bundleRequestId) applyGenderCounts();
        });

    $('body').on('change', 'input.bundle-builder__toggle-input', async function() {
        $('.bundle-builder__category--level-1').removeClass('active_level');
        const $parent = $(this).closest('.bundle-builder__categories');
        const levelFirst = $parent.find('.bundle-builder__category--level-1').first();
        const levelSecound = $parent.find('.bundle-builder__category--level-1').last();
        
        let activeLevelOne = levelFirst.attr('data-handle');
        if ($(this).prop('checked')) {
            levelSecound.addClass('active_level');
            activeLevelOne = levelSecound.attr('data-handle');
        } else {
            levelFirst.addClass('active_level');
            activeLevelOne = levelFirst.attr('data-handle');
        }
        
        $(`.bundle-builder__level-2`).removeClass('active_level');
        const levelTwo = $(`.bundle-builder__level-2[data-parent="${activeLevelOne}"]`);
        if (!levelTwo.length) return;

        levelTwo.addClass('active_level');
        levelTwo.find('.bundle-builder__category--level-2').removeClass('active_level');
        levelTwo.find('.bundle-builder__category--level-2').first().addClass('active_level');
        let activeLevelTwo = levelTwo.find('.bundle-builder__category--level-2').first().attr('data-handle');
        
        $(`.bundle-builder__level-3`).removeClass('active_level');
        const levelThrid = $(`.bundle-builder__level-3[data-parent-one="${activeLevelOne}"][data-parent-two="${activeLevelTwo}"]`);
        if (!levelThrid.length) return;
        
        levelThrid.addClass('active_level');    
        levelThrid.find('.bundle-builder__category--level-3').removeClass('active_level');
        levelThrid.find('.bundle-builder__category--level-3').first().addClass('active_level');
        await fetchCollection();
    })

    $('body').on('click', '.bundle-builder__category--level-2', async function() {
        $(`.bundle-builder__category--level-2`).removeClass('active_level');
        $(this).addClass('active_level');
        const parentEle = $(this).closest('.bundle-builder__level-2');
        if (!parentEle.length) return;

        let activeLevelOne = parentEle.attr('data-parent'); 
        let activeLevelTwo = $(this).attr('data-handle'); 

        $(`.bundle-builder__level-3`).removeClass('active_level');
        const levelThrid = $(`.bundle-builder__level-3[data-parent-two="${activeLevelTwo}"]`);
        if (!levelThrid.length) return;
        
        levelThrid.addClass('active_level');
        levelThrid.find('.bundle-builder__category--level-3').removeClass('active_level');
        levelThrid.find('.bundle-builder__category--level-3').first().addClass('active_level');
        await fetchCollection();
    })

    $('body').on('click', '.bundle-builder__category--level-3', async function() {
        $(`.bundle-builder__category--level-3`).removeClass('active_level');
        $(this).addClass('active_level');
        await fetchCollection();
    })


    // Switching category loads the new collection without the previous
    // collection's filters, since filter values differ per collection.
    async function fetchCollection() {
        let $levelThreeEle = $('.bundle-builder__level-3.active_level')
            .find('.bundle-builder__category--level-3.active_level');

        let collectionUrl = $levelThreeEle.attr('data-parent-third-url');

        if (!$levelThreeEle.length) {
            $levelThreeEle = $('.bundle-builder__level-3.active_level');
            collectionUrl = $levelThreeEle.attr('data-parent-two-url');
        }

        if (!collectionUrl) return;

        await loadBundleCollection(collectionUrl);
    }

    await fetchCollection();

    $('body').on('click', '.js-collection-side-filter, .js-current-filter', async function(e) {
        e.preventDefault();
        e.stopPropagation();
        const filterURL = $(this).attr('href');
        if (!filterURL) return;

        // Filter links were rendered with whatever sort was active at the time;
        // carry over a sort chosen since, so a quick sort -> filter keeps both.
        const nextUrl = new URL(filterURL, window.location.origin);
        const currentUrl = $('.bundle-builder__categories').attr('data-collection');
        const currentSort = currentUrl && new URL(currentUrl, window.location.origin).searchParams.get('sort_by');
        if (currentSort && nextUrl.pathname === new URL(currentUrl, window.location.origin).pathname) {
            nextUrl.searchParams.set('sort_by', currentSort);
        }
        await loadBundleCollection(nextUrl.pathname + nextUrl.search);
    })

    $('body').on('click', '.js-hz-filter-list li', async function(e) {
        e.preventDefault();
        e.stopPropagation();
        let sortBy = $(this).find('input').val();
        if (!sortBy) return;
        let filterURL = $('.bundle-builder__categories').attr('data-collection');
        if (!filterURL) return;
        const newUrl = new URL(filterURL, window.location.origin);
        newUrl.searchParams.set('sort_by', sortBy);

        // loadBundleCollection sets the sort label from the response.
        await loadBundleCollection(newUrl.pathname + newUrl.search);
    })

    $('body').on('change', 'select.bundle-card__select', function() {
        const parent = $(this).closest('.bundle-builder__card');
        if (!parent.length) return;
        let option1 = null, option2 = null, option3 = null, selectedOption = null;
        if (parent.find('select.bundle-card__select[name="option1"]')) {
            option1 = parent.find('select.bundle-card__select[name="option1"]').val();
        }
        if (parent.find('select.bundle-card__select[name="option2"]')) {
            option2 = parent.find('select.bundle-card__select[name="option2"]').val();
        }
        if (parent.find('select.bundle-card__select[name="option3"]')) {
            option3 = parent.find('select.bundle-card__select[name="option3"]').val();
        }

        if (option1 && option2 && option3) {
            selectedOption = parent.find(`select.variant__select[name="variant"] option[data-option1="${option1}"][data-option2="${option2}"][data-option3="${option3}"]`);
        } else if (option1 && option2) {
            selectedOption = parent.find(`select.variant__select[name="variant"] option[data-option1="${option1}"][data-option2="${option2}"]`);
        } else if (option1) {
            selectedOption = parent.find(`select.variant__select[name="variant"] option[data-option1="${option1}"]`);
        }
        
        if (selectedOption) {
            const variantId = selectedOption.attr('value');
            const variantTitle = selectedOption.attr('data-title');
            const price = selectedOption.attr('data-price');
            const priceCompare = selectedOption.attr('data-compare-price');
            const priceMoney = selectedOption.attr('data-price-money');
            const priceCompareMoney = selectedOption.attr('data-compare-price-money');
            const available = selectedOption.attr('data-available');
            const addToCartBtn = parent.find('#CardAddToCart');

            if (available == 'true' && addToCartBtn) {
                addToCartBtn.html('Add to Bundle');
                addToCartBtn.prop('disabled', false);
            } else if (addToCartBtn) {
                addToCartBtn.html('Sold Out');
                addToCartBtn.prop('disabled', true);
            }

            const priceEle = parent.find('.bundle-card__price--sale');
            const priceCompareEle = parent.find('.bundle-card__price--compare');

            if (variantTitle && addToCartBtn) {
                addToCartBtn.attr('data-variant-title', variantTitle);
            }
            if (priceMoney && priceEle) {
                priceEle.html(priceMoney);
            }
            if (priceCompareMoney && priceCompareEle) {
                priceCompareEle.html(priceCompareMoney);
            }
            if (variantId && addToCartBtn) {
                addToCartBtn.attr('data-variant-id', variantId);
            }
            
            if (price && addToCartBtn) {
                addToCartBtn.attr('data-variant-price', price);
            }
            
            if (priceCompare && addToCartBtn) {
                addToCartBtn.attr('data-variant-compare', priceCompare);
            }

        }
    })

$('body').on('click', '#CardAddToCart', function (e) {
  e.preventDefault();
  const variantId = $(this).attr('data-variant-id');
  const productTitle = $(this).attr('data-product-title');
  const variantOption = $(`select.variant__select option[value="${variantId}"]`);
  if (!variantOption.length) return;
  const variantTitle = variantOption.attr('data-title');
  const variantPrice = variantOption.attr('data-price');
  const variantCompare = variantOption.attr('data-compare-price');
  const variantPriceMoney = variantOption.attr('data-price-money');
  const variantCompareMoney = variantOption.attr('data-compare-price-money');
  const variantImg = variantOption.attr('data-img');
  const variantAvailable = variantOption.attr('data-available');
  
  const selectedCollection = ($('.bundle-builder__category--level-2.active_level').attr('data-handle') || '').toLowerCase();
  const normalize8 = (str) => (str.length > 8 ? str.slice(0, 8) : str);

  const selectedKey = normalize8(selectedCollection);

  $('.bundle-builder__sidebar .bundle-builder__progress-step').each(function () {
    const stepHandle = ($(this).attr('data-product') || '').toLowerCase();
    const stepKey = normalize8(stepHandle);
    if (selectedKey === stepKey) {
      $(this).addClass('added');
      return false;
    }
  });

  $('.bundle-builder__sidebar .bundle-builder__item').each(function () {
    const stepHandle = ($(this).attr('data-product') || '').toLowerCase();
    const stepKey = normalize8(stepHandle);
    if (selectedKey === stepKey) {
        $(this).attr('data-variant', variantId);
        $(this).attr('data-price', variantPrice);
        $(this).attr('data-compare-price', variantCompare);
        $(this).find('.bundle-item__image img').attr('src', variantImg);
        $(this).find('.bundle-item__title h4').html(productTitle);
        $(this).find('.bundle-item__price.bundle-item__price--sale').html(variantPriceMoney);
        $(this).find('.bundle-item__price.bundle-item__price-compare').html(variantCompareMoney);
        $(this).find('.bundle-item__variant span').html(variantTitle);
        $(this).addClass('active_card');
        if($('.bundle-builder__progress-step.added').length == 3) {
            $('.bundle-builder__summary-progress__bar span').css('opacity', '1');
        } else if ($('.bundle-builder__progress-step.added').length == 2) {
            if ($('.bundle-builder__progress-step[data-product="top"]').hasClass('added') && $('.bundle-builder__progress-step[data-product="bottom"]').hasClass('added')) {
                $('.bundle-builder__summary-progress__bar span').css('opacity', '0');
                $('.bundle-builder__summary-progress__bar span.first_half').css('opacity', '1');
            } else if ($('.bundle-builder__progress-step[data-product="bottom"]').hasClass('added') && $('.bundle-builder__progress-step[data-product="accessory"]').hasClass('added')) {
                $('.bundle-builder__summary-progress__bar span').css('opacity', '0');
                $('.bundle-builder__summary-progress__bar span.second_half').css('opacity', '1');
            } else {
                $('.bundle-builder__summary-progress__bar span').css('opacity', '0');
            }
        } else {
            $('.bundle-builder__summary-progress__bar span').css('opacity', '0');
        }

        updateBundlePrice();
        return false;
    }
  });

});

$('body').on('click', '#RemoveBundleItem', function (e) {
  e.preventDefault();
    const parentEle = $(this).closest('.bundle-builder__item');
    parentEle.removeClass('active_card');
    const collectionHandle = parentEle.attr('data-product');
    const variantImg = parentEle.find('.bundle-item__image img').attr('data-src');
    parentEle.attr('data-variant', '');
    parentEle.attr('data-price', '');
    parentEle.attr('data-compare-price', '');
    parentEle.find('.bundle-item__image img').attr('src', variantImg);
    parentEle.find('.bundle-item__price.bundle-item__price--sale').html('');
    parentEle.find('.bundle-item__price.bundle-item__price-compare').html('');
    parentEle.find('.bundle-item__variant span').html('');
    $(`.bundle-builder__progress-step[data-product="${collectionHandle}"]`).removeClass('added');
    
    if($('.bundle-builder__progress-step.added').length == 3) {
        $('.bundle-builder__summary-progress__bar span').css('opacity', '1');
    } else if ($('.bundle-builder__progress-step.added').length == 2) {
        if ($('.bundle-builder__progress-step[data-product="top"]').hasClass('added') && $('.bundle-builder__progress-step[data-product="bottom"]').hasClass('added')) {
            $('.bundle-builder__summary-progress__bar span').css('opacity', '0');
            $('.bundle-builder__summary-progress__bar span.first_half').css('opacity', '1');
        } else if ($('.bundle-builder__progress-step[data-product="bottom"]').hasClass('added') && $('.bundle-builder__progress-step[data-product="accessory"]').hasClass('added')) {
            $('.bundle-builder__summary-progress__bar span').css('opacity', '0');
            $('.bundle-builder__summary-progress__bar span.second_half').css('opacity', '1');
        } else {
            $('.bundle-builder__summary-progress__bar span').css('opacity', '0');
        }
    } else {
        $('.bundle-builder__summary-progress__bar span').css('opacity', '0');
    }

    updateBundlePrice();
});

function updateBundlePrice () {
    let totalPrice = 0;
    let totalComparePrice = 0;
    $('.bundle-builder__sidebar .bundle-builder__item.active_card').each(function () {
        totalPrice += parseInt($(this).attr('data-price'));
        totalComparePrice += parseInt($(this).attr('data-compare-price'));
    });
    if (totalPrice != 0) {
        $('.bundle-builder__price-before span').html(theme.Helpers.formatMoney(totalPrice));
    }

    var addedCount = $('.bundle-builder__sidebar .bundle-builder__progress-step.added').length;

    // Find the applicable discount based on min_prod
    var applicableDiscount = 0;
    var ruleMatched = false;
    bundleDiscountRules.forEach(function(rule) {
      if (addedCount >= rule.min_prod && rule.discount > applicableDiscount) {
        applicableDiscount = rule.discount;
        ruleMatched = true;
      }
    });

    // Calculate price after discount
    var priceAfterDiscount = totalPrice - (totalPrice * applicableDiscount / 100);

    // Update UI
    if (!ruleMatched || addedCount <= 1) {
        $('button#BundleAddToCart').prop('disabled', true);
        $('.bundle-builder__pricing .total_compare_price_bundle').hide();
        $('.bundle-builder__pricing .total_save_price_bundle').hide();
        $('.bundle-builder__price-current span').html(theme.Helpers.formatMoney(totalPrice));
        $('.bundle-builder__savings span').html("0%");
    } else {
        // Enable button if at least one discount applies
        $('button#BundleAddToCart').prop('disabled', false);
        $('.bundle-builder__price-current span').html(theme.Helpers.formatMoney(priceAfterDiscount));
        $('.bundle-builder__savings span').html(applicableDiscount + "%");
        $('.bundle-builder__pricing .total_compare_price_bundle').css('display', 'flex');
        $('.bundle-builder__pricing .total_save_price_bundle').css('display', 'flex');
    }

}

// document.addEventListener("CollectionUpdated", function(){
//     console.log('CollectionUpdated');
//     const activeCollection = $('.bundle-builder__category--level-2.active_level').attr('data-handle');
//     $('.bundle-builder__sidebar .bundle-builder__item.active_card').each(function () {
//         const activeCard = $(this).attr('data-product');
//     });
// });

function generateUID() {
    var firstPart = (Math.random() * 46656) | 0;
    var secondPart = (Math.random() * 46656) | 0;
    firstPart = ("000" + firstPart.toString(36)).slice(-3);
    secondPart = ("000" + secondPart.toString(36)).slice(-3);
    return firstPart + secondPart;
}

$('body').on('click', 'button#BundleAddToCart:not([disabled])', async function(e) {
    e.preventDefault();
    $(this).prop('disabled', true);
    $(this).html('Adding Bundle...');
    let bundleData = [];
    let set_id = generateUID();
    $('.bundle-builder__sidebar .bundle-builder__item.active_card').each(function () {
        let bundleItem = { quantity: 1, id: parseInt($(this).attr('data-variant')) };
        bundleItem["properties"] = {
            '_bundled-product': true,
            '_set_id': set_id
        };
        bundleData.push(bundleItem);
    });

    if (bundleData.length > 0) {
        try {
            const response = await fetch(`/cart/add.js`, {
                body: JSON.stringify({ items: bundleData }),
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'xmlhttprequest'
                },
                method: 'POST'
            });
            const responseJson = await response.json();

            if (!response.ok) {
                throw new Error(responseJson["description"] || "Error adding items to cart");
            }

            if(response.ok) {
              const event = new Event('cart:show');
              document.dispatchEvent(event);
            } else {
              alert('Could not add items. Please try again later.')
            }
            $('button#RemoveBundleItem').each(function () {
                $(this).click();
            });

            $(this).prop('disabled', false);
            $(this).html('Add Bundle to Cart');
            updateCartDrawer();
            setTimeout(() => { openCartDrawer() }, 2000);
        } catch (err) {
            console.error('fetchCollection failed:', err);
            throw err;
        }
        
        $(this).prop('disabled', false);
        $(this).html('Add Bundle to Cart');
    }
});


// Sync Price slider <-> Min/Max inputs (works with dynamic HTML using event delegation)

  function getEls($wrap) {
    return {
      $minInput:  $wrap.find('.js-price-min-output'),
      $maxInput:  $wrap.find('.js-price-max-output'),
      $minSlider: $wrap.find('.filter-range__slider--input').eq(0),
      $maxSlider: $wrap.find('.filter-range__slider--input').eq(1)
    };
  }

  // An empty box means "no limit on that side" (the Max box is empty until a
  // max filter is active), so it falls back to that side's bound rather than 0.
  function clamp(v, fallback, min, max) {
    v = parseFloat(v);
    if (isNaN(v)) v = fallback;
    return Math.min(Math.max(v, min), max);
  }

  // changed: 'min' / 'max' when a slider thumb moved, so it stops at the other
  // thumb instead of swapping under the pointer; omitted for typed values.
  function setValues($wrap, minVal, maxVal, changed) {
    const els = getEls($wrap);
    if (!els.$minInput.length || !els.$maxInput.length || !els.$minSlider.length || !els.$maxSlider.length) return;

    const MIN = parseFloat(els.$minSlider.attr('min')) || 0;
    const MAX = parseFloat(els.$minSlider.attr('max')) || 0;

    minVal = clamp(minVal, MIN, MIN, MAX);
    maxVal = clamp(maxVal, MAX, MIN, MAX);

    if (minVal > maxVal) {
      if (changed === 'min') minVal = maxVal;
      else if (changed === 'max') maxVal = minVal;
      else [minVal, maxVal] = [maxVal, minVal];
    }

    els.$minInput.val(minVal);
    els.$maxInput.val(maxVal);
    els.$minSlider.val(minVal);
    els.$maxSlider.val(maxVal);

    return { minVal: minVal, maxVal: maxVal, MIN: MIN, MAX: MAX };
  }

  // Only sends the bounds the shopper actually narrowed, so a Min-only entry
  // filters "from $X" and a full-range entry clears the price filter.
  function applyPriceFilter(priceFilter) {
    if (!priceFilter) return;
    const collectionUrl = $('.bundle-builder__categories').attr('data-collection');
    if (!collectionUrl) return;
    const newUrl = new URL(collectionUrl, window.location.origin);
    const before = newUrl.search;

    if (priceFilter.minVal > priceFilter.MIN) {
        newUrl.searchParams.set('filter.v.price.gte', priceFilter.minVal);
    } else {
        newUrl.searchParams.delete('filter.v.price.gte');
    }
    if (priceFilter.maxVal < priceFilter.MAX) {
        newUrl.searchParams.set('filter.v.price.lte', priceFilter.maxVal);
    } else {
        newUrl.searchParams.delete('filter.v.price.lte');
    }

    if (newUrl.search === before) return;
    return loadBundleCollection(newUrl.pathname + newUrl.search);
  }

  // Slider -> Inputs (dynamic). Sync visually while dragging, fetch on release.
  $('body').on('input', '[data-collection-filters-price-range] .filter-range__slider--input', function () {
    const $wrap = $(this).closest('[data-collection-filters-price-range]');
    const els = getEls($wrap);
    setValues($wrap, els.$minSlider.val(), els.$maxSlider.val(), this === els.$minSlider[0] ? 'min' : 'max');
  });

  $('body').on('change', '[data-collection-filters-price-range] .filter-range__slider--input', async function (e) {
    e.preventDefault();
    const $wrap = $(this).closest('[data-collection-filters-price-range]');
    const els = getEls($wrap);
    await applyPriceFilter(setValues($wrap, els.$minSlider.val(), els.$maxSlider.val(), this === els.$minSlider[0] ? 'min' : 'max'));
  });

  // Inputs -> Slider (dynamic). Applying reloads the sidebar, so wait until the
  // user presses Enter or leaves the price box entirely; tabbing Min -> Max
  // must not destroy the Max input mid-typing.
  function applyPriceInputs($wrap) {
    const els = getEls($wrap);
    return applyPriceFilter(setValues($wrap, els.$minInput.val(), els.$maxInput.val()));
  }

  $('body').on('keydown', '[data-collection-filters-price-range] .js-price-min-output, [data-collection-filters-price-range] .js-price-max-output', async function (e) {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    await applyPriceInputs($(this).closest('[data-collection-filters-price-range]'));
  });

  $('body').on('focusout', '[data-collection-filters-price-range]', async function (e) {
    // Applies from any element (a typed value survives tabbing through a
    // slider); an unchanged range is a no-op in applyPriceFilter.
    if (e.relatedTarget && this.contains(e.relatedTarget)) return;
    await applyPriceInputs($(this));
  });

  // Optional: initial sync if it exists on load
  $('[data-collection-filters-price-range]').each(function () {
    const $wrap = $(this);
    const els = getEls($wrap);
    if (els.$minSlider.length && els.$maxSlider.length) {
      setValues($wrap, els.$minSlider.val(), els.$maxSlider.val());
    }
  });



}); 